var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer flex-row"},[_c('span',[_c('center',[_vm._v("@"),_c('a',{attrs:{"href":"https://www.neogeo.fr/"}},[_vm._v("Neogeo Technologies")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }